export class ParentHandler {
  handle(pathData) {
    let node = pathData;
    while (node.parent)
      node = node.parent;
    return node;
  }
}
